module.exports = __webpack_public_path__ + "img/img2.d8988c4a.png";